import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 'calc(100vh - 144px)',
      overflowY: 'auto',
    },
    root1: {
      height: 'calc(100vh - 194px)',
      overflowY: 'auto',
    },
    card: {
      padding: '16px',
      overflowY: 'hidden',
      borderRadius: 0,
      '& .heading': {
        fontSize: '30px',
        fontWeight: 300,
      },
      '& .outerGrid': {
        padding: '35px 0px 27px 27px',
        margin: '8px 0px 0px 0px',
      },
      '&  .selectAllBlock': {
        padding: '18px 0px 18px 27px ',
        margin: '8px 0px 8px 0px',
      },
    },
    formControl: {
      width: '100%',
      flexFlow: 'wrap',
    },
    checklistSaveButtonGrid: {
      '& #checklistSaveButtonIsNotChanged': {
        backgroundColor: 'rgba(255, 255, 255, 0.46)',
        borderRadius: '4px',
        width: 'fit-content',
      },
      '& #checklistSaveButtonIsChanged': {
        backgroundColor: '',
        borderRadius: '4px',
        width: 'fit-content',
      },
      '& #checklistSaveButtonInnerGrid': {
        fontWeight: 700,
        color: MaterialPalette.common.black,
      },
    },
    checkboxFieldGrid: {
      overflowWrap: 'anywhere',
      height: '60px',
    },
  }),
);

export default useStyles;
